export { default as StarsIcon } from "./stars";
export { default as PlayIcon } from "./play";
export { default as PauseIcon } from "./pause";
export { default as PlayCircleIcon } from "./playCircle";
export { default as FlashIcon } from "./flash";
export { default as PhotoIcon } from "./photo";
export { default as LocationIcon } from "./location";
export { default as CallIcon } from "./call";
export { default as DateTimeIcon } from "./dateTime";
